import React from 'react';
import { ObjectTable } from './object-table';
import { Table as PlainTable } from './plain-table';
import { TableListView } from './table-list-view';
export const Table = () => React.createElement(React.Fragment, null);
Table.Table = PlainTable;
Table.ListView = TableListView;
Table.ObjectTable = ObjectTable;
//# sourceMappingURL=table.js.map